/* eslint-disable max-len */
import React from "react";
import cn from "classnames";

import MuseLogo from "../Logos/MuseLogo";
import FooterColumn from "./FooterColumn";
import FooterColumnItem from "./FooterColumnItem";
import {
    Facebook, LinkedIn, Twitter, Pinterest, Instagram
} from "../Icons";

import styles from "./Footer.module.scss";

interface FooterInterface extends React.HTMLProps<HTMLElement> {
    showRebrand?: boolean;
}

const Footer = (props: FooterInterface) => {
    const { className, ...restProps } = props;
    const aboutColumnLinkProps = [
        {
            text: "About Us",
            url: "/about"
        },
        {
            text: "FAQs",
            url: "https://desk.zoho.com/portal/themuse/en/kb/the-muse"
        },
        {
            text: "Search Jobs",
            url: "/search"
        },
        {
            text: "Browse Companies",
            url: "/companies"
        },
        {
            text: "Career Advice",
            url: "/advice"
        },
        {
            text: "Terms of Use",
            url: "/user/terms"
        },
        {
            text: "Privacy Policy",
            url: "/user/privacy"
        }
        ,
        {
            text: "FairyGodBoss",
            url: "https://fairygodboss.com"
        }
    ];

    const popularColumnLinkProps = [
        {
            text: "New York Jobs",
            url: "/hiring/location/new-york-ny/?ref=footer"
        },
        {
            text: "San Francisco Jobs",
            url: "/hiring/location/san-francisco-ca/?ref=footer"
        },
        {
            text: "Seattle Jobs",
            url: "/hiring/location/seattle-wa/?ref=footer"
        },
        {
            text: "Engineering Jobs",
            url: "/hiring/keyword/engineering/?ref=footer"
        },
        {
            text: "Marketing Jobs",
            url: "/hiring/keyword/marketing/?ref=footer"
        },
        {
            text: "Information Technology Jobs",
            url: "/hiring/keyword/information-technology/?ref=footer"
        },
        {
            text: "Salaries",
            url: "/salaries"
        },
        {
            text: "Search Job Titles",
            url: "/browse/job-titles"
        },
    ];

    const involvedColumnLinkProps = [
        {
            text: "For Employers",
            url: "/employers"
        },
        {
            text: "The Muse Book: The New Rules of Work",
            url: "/thenewrulesofwork"
        },
        {
            text: "Podcast: The New Rules of Work",
            url: "/employers/thenewrulesofworkpodcast"
        },
        {
            text: "For Career Coaches",
            url: "/startcoaching"
        },
        {
            text: "Tell A Friend",
            url: "/friends"
        }
    ];

    const socialColumnLinkProps = [
        {
            Component: <Facebook title="Facebook" />,
            url: "https://www.facebook.com/thedailymuse"
        },
        {
            Component: <LinkedIn title="LinkedIn" />,
            url: "https://www.linkedin.com/company/the-daily-muse"
        },
        {
            Component: <Twitter title="Twitter" />,
            url: "https://twitter.com/TheMuse"
        },
        {
            Component: <Pinterest title="Pinterest" />,
            url: "https://pinterest.com/thedailymuse/"
        },
        {
            Component: <Instagram title="Instagram" />,
            url: "https://instagram.com/themuse/"
        },
    ];

    return (
        <footer {...restProps} className={cn(styles.footer, className)}>
            <div className={cn(styles.container)}>
                <div className={styles.logoCopyright}>
                    <a
                        className={styles.anchor}
                        href="/"
                        aria-label="Home Page"
                        onMouseUp={(e: React.MouseEvent<HTMLAnchorElement>) => {
                            e.currentTarget.blur();
                        }}
                    >
                        <MuseLogo className={styles.museLogo} titleId="logo-footer-title" />
                    </a>
                    <div className={styles.copyright}>{`\u{a9} ${new Date().getFullYear()} Daily Muse Inc.`}</div>
                </div>
                <FooterColumn className={styles.aboutTheMuse} title="About The Muse">
                    {aboutColumnLinkProps.map(({ text, url }) => (
                        <FooterColumnItem key={url} href={url}>{text}</FooterColumnItem>
                    ))}
                </FooterColumn>
                <FooterColumn className={styles.popularJobs} title="Popular Jobs">
                    {popularColumnLinkProps.map(({ text, url }) => (
                        <FooterColumnItem key={url} href={url}>{text}</FooterColumnItem>
                    ))}
                </FooterColumn>
                <FooterColumn className={styles.getInvolved} title="Get Involved">
                    {involvedColumnLinkProps.map(({ text, url }) => (
                        <FooterColumnItem key={url} href={url}>{text}</FooterColumnItem>
                    ))}
                </FooterColumn>
                <FooterColumn className={styles.joinConversation} title="Join The Conversation">
                    {socialColumnLinkProps.map(({ Component, url }) => (
                        <FooterColumnItem key={url} href={url}>{Component}</FooterColumnItem>
                    ))}
                </FooterColumn>
            </div>
        </footer>
    );
};

export { Footer as default };
